import styled from "styled-components";

export const FilterCategoryDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 10px 15px;
    min-height: 56px;
    
    &:not(:last-of-type){
        border-bottom: 1px solid ${props => props.theme.colors.backgroundMiddleDark};
    }
`;
